import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { DsButtonModule, DsLoadingModule, DsTooltipDirectiveModule } from '@bmw-ds/components';

@Component({
  selector: 'cdf-search-button',
  imports: [DsButtonModule, DsLoadingModule, DsTooltipDirectiveModule],
  template: `
    <button
      ds-button
      ds-loading
      icon="search"
      type="submit"
      [id]="id()"
      [disabled]="disabled()"
      [ds-tooltip]="tooltip()"
      size="md"
      (click)="searchClick.emit()"
      [isLoading]="isLoading() ?? false"
    >
      {{ label() }}
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchButtonComponent {
  readonly id = input.required<string>();
  readonly label = input.required<string>();
  readonly disabled = input.required<boolean>();
  readonly tooltip = input<string>('');
  readonly isLoading = input<boolean>();
  readonly searchClick = output();
}
